import Link from 'next/link'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { MyImage } from '../ui/MyImage'
import { FormOutlined, DeleteOutlined } from '@ant-design/icons'
import { getCollectionList_marketingModule_collectionList_edges_node } from '~/graphqls/types'
import { useRouter } from 'next/router'
import UserBadge from './UserBadge'
import { VipIcon } from '~/components/icon/Vip'

const StyledSingleCollection = styled.div`
  position: relative;
  border: 1px solid ${props => props.theme.light1};
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 32px;
  background: ${props => props.theme.light3};
  .collection-action {
    position: absolute;
    top: 26px;
    right: 26px;
    left: 26px;
    height: 32px;
    z-index: 1;
    display: flex;
    justify-content: end;
  }
  .collection-action-item {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    width: 32px;
    height: 32px;
    vertical-align: middle;
    text-align: center;
    color: ${props => props.theme.light1};
    margin-left: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .collection-image {
    border-radius: 8px;
    height: 112px;
    margin-bottom: 16px;
  }
  .collection-title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: ${props => props.theme.dark2};
  }
  .collection-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .collection-creator {
    display: flex;
  }
  .creator-avatar-wrap {
    position: relative;
    height: 20px;
    width: 20px;
    margin: 0 auto;
  }
  .creator-avatar {
    height: 100%;
    width: 100%;
    border-radius: 50%;
  }

  .creator-name {
    margin-left: 6px;
    font-size: 12px;
    line-height: 20px;
    color: ${props => props.theme.dark2};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 120px;
  }
  .collection-count {
    background: ${props => props.theme.light2};
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
    line-height: 20px;
    color: ${props => props.theme.dark2};
    span {
      font-weight: 600;
    }
  }
  .collection-desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    height: 40px;
    color: ${props => props.theme.dark4};
    /* TODO 抽离成mixins */
    word-break: break-all;
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    /*! autoprefixer: ignore next */
    -webkit-box-orient: vertical;
  }
`

export const SingleCollection: React.FC<{
  data: getCollectionList_marketingModule_collectionList_edges_node
  style?: React.CSSProperties
  editable?: boolean
  onDel?: (id: number) => void
}> = ({ data, style, editable = false, onDel: handleDel }) => {
  const router = useRouter()
  const onEdit = useCallback(
    (e, data) => {
      e.preventDefault()
      router.push(`/my/collection/${data.id}`)
    },
    [router]
  )

  const onDel = useCallback(
    (e, data) => {
      e.preventDefault()
      console.log('onDel')
      handleDel?.(data.id)
    },
    [handleDel]
  )

  return (
    <StyledSingleCollection style={style}>
      <Link href={`/collection/${data.id}`}>
        <a>
          {editable && (
            <div className="collection-action">
              <span
                className="collection-action-item"
                onClick={e => onEdit(e, data)}
              >
                <FormOutlined />
              </span>
              <span
                className="collection-action-item"
                onClick={e => onDel(e, data)}
              >
                <DeleteOutlined />
              </span>
            </div>
          )}
          <MyImage tag="v1200" className="collection-image" src={data.image} />
          <div className="collection-title text-overflow">{data.name}</div>
          <div className="collection-info">
            <div className="collection-creator">
              <div className="creator-avatar-wrap">
                <MyImage
                  tag="v400"
                  className="creator-avatar"
                  src={data.creator?.avatar}
                />
                <VipIcon
                  userRole={data.creator?.userRoleInfo}
                  className="h-[10px] -right-[3.5px] max-w-[15px]"
                />
              </div>

              <span className="creator-name flex items-center">
                <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                  {data.creator?.name}
                </span>
                <UserBadge
                  type={data.creator?.userType}
                  className="ml-1 !w-[14px] !h-[14px] flex-shrink-0"
                />
              </span>
            </div>
            <div className="collection-count">
              <span>{data.artworkCount}</span> 作品
            </div>
          </div>
          <div className="collection-desc">{data.description}</div>
        </a>
      </Link>
    </StyledSingleCollection>
  )
}
